import React, { useEffect, useState } from 'react';
import './InputField.scss';
import eyeBlind from '../assets/eye-blind.png';
import eye from '../assets/eye.png';
import LockIcon from '../assets/lock.png';
import { passwordStrength } from 'check-password-strength';
/* eslint-disable-next-line */
const password = require('secure-random-password');
export type InputType = 'text' | 'number' | 'password' | 'email' | 'checkbox';

interface InputFieldProps {
  type: InputType;
  style?: React.CSSProperties;
  visible?: boolean;
  renderIcon?: boolean;
  onWatchPassword?: () => void;
  value?: string;
  required?: boolean;
  placeholder?: string;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  lock?: boolean;
  iconStyle?: React.CSSProperties;
}

export const InputField: React.FC<InputFieldProps> = (props) => {
  const [visible, setVisible] = useState<boolean>(false);
  const [inputType, setInputType] = useState<InputType>(props.type);

  const onWatchChange = () => {
    setVisible(!visible);
  };
  useEffect(() => {
    if (visible) {
      setInputType('text');
    } else {
      setInputType('password');
    }
  }, [visible]);

  const generatePassword = () => {
    return password.randomPassword({
      characters: [
        { characters: password.upper, exactly: 1 },
        { characters: password.symbols, exactly: 1 },
        { characters: password.lower, exactly: 1 },
        { characters: password.digits },
      ],
    });
  };

  const onLockClick = (e) => {
    let passwords = generatePassword();
    let strength = passwordStrength(passwords);
    while (strength.value !== 'Strong') {
      passwords = generatePassword();
      strength = passwordStrength(passwords);
    }
    e.target.value = passwords;

    props.onChange(e);
  };

  return (
    <div style={{ position: 'relative', width: '100%' }}>
      <input
        type={props.renderIcon ? inputType : props.type}
        style={props.style}
        value={props.value}
        required={props.required}
        className="input-field"
        placeholder={props.placeholder}
        onChange={props.onChange}
      />
      <span className="icon" style={props.iconStyle}>
        <span>
          {props.renderIcon ? (
            props.lock ? (
              <img onClick={(e) => onLockClick(e)} src={LockIcon} alt="lock" />
            ) : null
          ) : null}
        </span>
        <span onClick={onWatchChange}>
          {props.renderIcon ? visible ? <img src={eye} alt="eye" /> : <img src={eyeBlind} alt="eye-close" /> : null}
        </span>
      </span>
    </div>
  );
};
